"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CreateNewApplicationButton = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Form = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Form"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _TierPreview = _interopRequireDefault(require("@mulesoft/client-applications-ui/raw/components/TierPreview"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _Select = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Select"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _utils = require("./utils");
var _AcceptTerms = _interopRequireDefault(require("../AcceptTerms"));
var _excluded = ["normalizedLimitsByAPI"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable react/no-unstable-nested-components */
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
  }));
};
PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "modal": "RequestAccessModal__modal__21GSg",
  "header": "RequestAccessModal__header__176tA",
  "body": "RequestAccessModal__body__2IZsi",
  "footer": "RequestAccessModal__footer__146cz",
  "title": "RequestAccessModal__title__2-WYg",
  "sla-details": "RequestAccessModal__sla-details__2qE2W",
  "slaDetails": "RequestAccessModal__sla-details__2qE2W",
  "sla-tier-limits": "RequestAccessModal__sla-tier-limits__1R6k4",
  "slaTierLimits": "RequestAccessModal__sla-tier-limits__1R6k4",
  "errors": "RequestAccessModal__errors__1VSon",
  "group-title": "RequestAccessModal__group-title__3iBfs",
  "groupTitle": "RequestAccessModal__group-title__3iBfs"
}; 
require('./RequestAccessModal.css');
var SelectTheme = {
  "select-input": "SelectTheme__select-input__1lB0D",
  "selectInput": "SelectTheme__select-input__1lB0D"
}; 
require('./SelectTheme.css');
var ApplicationSelectTheme = {
  "select-input": "ApplicationSelectTheme__select-input__3rHfe",
  "selectInput": "ApplicationSelectTheme__select-input__3rHfe",
  "select-menu-outer": "ApplicationSelectTheme__select-menu-outer__lLaGw",
  "selectMenuOuter": "ApplicationSelectTheme__select-menu-outer__lLaGw",
  "fixed-action": "ApplicationSelectTheme__fixed-action__1Vv9y",
  "fixedAction": "ApplicationSelectTheme__fixed-action__1Vv9y"
}; 
require('./ApplicationSelectTheme.css');
var ApplicationSelectThemeHidden = {
  "select-menu-outer": "ApplicationSelectThemeHidden__select-menu-outer__23lco",
  "selectMenuOuter": "ApplicationSelectThemeHidden__select-menu-outer__23lco",
  "fixed-action": "ApplicationSelectThemeHidden__fixed-action__FV9WK",
  "fixedAction": "ApplicationSelectThemeHidden__fixed-action__FV9WK"
}; 
require('./ApplicationSelectThemeHidden.css');
var CreateNewApplicationButton = exports.CreateNewApplicationButton = function CreateNewApplicationButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    "data-test-id": "create-new-app-button",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(PlusIcon, null)), "Create a new application");
};
var isAPIGroup = function isAPIGroup(asset) {
  return asset.type === 'api-group';
};
var optionRenderer = function optionRenderer(option) {
  return /*#__PURE__*/_react.default.createElement("span", {
    title: option.label
  }, option.label);
};
var RequestAccessModal = exports.default = /*#__PURE__*/function (_React$Component) {
  function RequestAccessModal() {
    var _this;
    (0, _classCallCheck2.default)(this, RequestAccessModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RequestAccessModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      form: {},
      applications: [],
      slaTiers: [],
      isLoadingSLATiers: false,
      isLoadingApplications: false
    });
    (0, _defineProperty2.default)(_this, "getAPIGroupTiersWithNames", function (apiGroupInstanceId, slaTiers) {
      var managedInstances = _this.props.managedInstances;
      var _managedInstances$fin = managedInstances.find(function (_ref2) {
          var id = _ref2.id;
          return id.toString() === apiGroupInstanceId;
        }),
        apiInstances = _managedInstances$fin.apiInstances;
      return slaTiers.map(function (_ref3) {
        var normalizedLimitsByAPI = _ref3.normalizedLimitsByAPI,
          restOfTier = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
        return _objectSpread(_objectSpread({}, restOfTier), {}, {
          limitsByApi: apiInstances.map(function (_ref4) {
            var id = _ref4.id,
              name = _ref4.name,
              exchangeAssetName = _ref4.exchangeAssetName;
            var normalizedLimit = normalizedLimitsByAPI.find(function (limitByApi) {
              return limitByApi.apiId === id;
            });
            return _objectSpread(_objectSpread({}, normalizedLimit), {}, {
              name: exchangeAssetName,
              instanceName: name
            });
          })
        });
      });
    });
    (0, _defineProperty2.default)(_this, "getApplication", function (applicationId) {
      var applications = _this.state.applications;
      return applications.find(function (_ref5) {
        var id = _ref5.id;
        return id.toString() === applicationId;
      });
    });
    (0, _defineProperty2.default)(_this, "getManagedInstance", function (instanceId) {
      var managedInstances = _this.props.managedInstances;
      return managedInstances.find(function (_ref6) {
        var id = _ref6.id;
        return id.toString() === instanceId;
      });
    });
    (0, _defineProperty2.default)(_this, "getSLATier", function (slaTierId) {
      var slaTiers = _this.state.slaTiers;
      return slaTiers.find(function (_ref7) {
        var id = _ref7.id;
        return id.toString() === slaTierId;
      });
    });
    (0, _defineProperty2.default)(_this, "getManagedInstances", function () {
      return (_this.getVisibleManagedInstances() || []).filter(function (instance) {
        return !instance.deprecated;
      }).map(function (instance) {
        return {
          value: instance.id,
          label: instance.name,
          environmentName: instance.environmentName,
          environmentId: instance.environmentId
        };
      });
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (_ref8) {
      var value = _ref8.value,
        target = _ref8.target;
      var form = _this.state.form;
      switch (target) {
        case 'instanceId':
          {
            _this.handleInstanceChange(value.instanceId);
            break;
          }
        case 'slaTier':
          {
            _this.handleSLATierChange(value.slaTier);
            break;
          }
        default:
          {
            _this.setState({
              form: _objectSpread(_objectSpread({}, form), {}, (0, _defineProperty2.default)({}, target, value[target]))
            });
          }
      }
    });
    (0, _defineProperty2.default)(_this, "onCreateNewApplication", function () {
      var form = _this.state.form;
      var onCreateNewApplication = _this.props.onCreateNewApplication;
      var selectedInstance = _this.getManagedInstance(form.instanceId);
      var providerId = selectedInstance === null || selectedInstance === void 0 ? void 0 : selectedInstance.providerId;
      var callback = function callback(application) {
        _this.setState(function (state) {
          return {
            applications: [].concat((0, _toConsumableArray2.default)(state.applications), [application]),
            form: _objectSpread(_objectSpread({}, form), {}, {
              applicationId: application.id.toString()
            })
          };
        });
      };
      onCreateNewApplication(providerId, form.instanceId, callback);
    });
    (0, _defineProperty2.default)(_this, "handleClose", function () {
      _this.setState({
        form: {}
      });
      var closeModal = _this.context.closeModal;
      closeModal();
    });
    (0, _defineProperty2.default)(_this, "handleSubmit", function () {
      var form = _this.state.form;
      var _this$props = _this.props,
        asset = _this$props.asset,
        masterOrganizationId = _this$props.masterOrganizationId,
        onCreateContract = _this$props.onCreateContract;
      var application = _this.getApplication(form.applicationId);
      var instance = _this.getManagedInstance(form.instanceId);
      var slaTier = _this.getSLATier(form.slaTier);
      onCreateContract({
        assetType: asset.type,
        masterOrganizationId: masterOrganizationId,
        applicationId: application.id,
        apiInstanceId: typeof instance.id === 'number' ? instance.id : parseInt(instance.id, 10),
        environmentId: instance.environmentId,
        slaTierId: slaTier === null || slaTier === void 0 ? void 0 : slaTier.id,
        organizationId: asset.organization.id,
        groupId: asset.groupId,
        assetId: asset.assetId,
        version: asset.version,
        versionGroup: asset.versionGroup
      });
    });
    (0, _defineProperty2.default)(_this, "handleInstanceChange", function (instanceId) {
      var form = _this.state.form;
      var masterOrganizationId = _this.props.masterOrganizationId;
      var currentInstanceId = form.instanceId;
      if (currentInstanceId !== instanceId) {
        _this.setState({
          form: _objectSpread(_objectSpread({}, form), {}, {
            slaTier: null,
            slaTierLimits: null,
            instanceId: instanceId
          })
        }, function () {
          if (!instanceId) {
            return;
          }
          var instance = _this.getManagedInstance(instanceId);
          _this.loadSLATiers(instance);
          _this.loadApplications(masterOrganizationId, instanceId);
        });
      }
    });
    (0, _defineProperty2.default)(_this, "handleSLATierChange", function (slaTierId) {
      var slaTierLimits = slaTierId ? _this.getSLATier(slaTierId).normalizedLimits : null;
      var form = _this.state.form;
      _this.setState({
        form: _objectSpread(_objectSpread({}, form), {}, {
          slaTier: slaTierId,
          slaTierLimits: slaTierLimits
        })
      });
    });
    (0, _defineProperty2.default)(_this, "loadApplications", /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(masterOrganizationId, instanceId) {
        var loadApplications, applications, _t;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loadApplications = _this.props.loadApplications;
              _this.setState({
                isLoadingApplications: true
              });
              _context.prev = 1;
              _context.next = 2;
              return loadApplications(masterOrganizationId, instanceId);
            case 2:
              applications = _context.sent;
              _this.setState({
                applications: applications,
                isLoadingApplications: false
              });
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              _this.setState({
                isLoadingApplications: false
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function (_x, _x2) {
        return _ref9.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(_this, "loadSLATiers", /*#__PURE__*/function () {
      var _ref0 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(instance) {
        var _this$props2, asset, domain, loadSLATiers, form, groupId, assetId, versionGroup, slaTierParams, fetchedTiers, slaTiers, _t2;
        return _regenerator.default.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, asset = _this$props2.asset, domain = _this$props2.domain, loadSLATiers = _this$props2.loadSLATiers;
              form = _this.state.form;
              groupId = asset.groupId, assetId = asset.assetId, versionGroup = asset.versionGroup;
              slaTierParams = {
                groupId: groupId,
                assetId: assetId,
                versionGroup: versionGroup,
                instance: instance
              };
              if (domain) {
                slaTierParams.domain = domain;
              }
              _this.setState({
                isLoadingSLATiers: true
              });
              _context2.prev = 1;
              _context2.next = 2;
              return loadSLATiers(slaTierParams);
            case 2:
              fetchedTiers = _context2.sent;
              slaTiers = isAPIGroup(asset) ? _this.getAPIGroupTiersWithNames(form.instanceId, fetchedTiers) : fetchedTiers;
              _this.setState({
                slaTiers: slaTiers
              }, function () {
                return _this.setState({
                  isLoadingSLATiers: false
                });
              });
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              _this.setState({
                isLoadingSLATiers: false
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 3]]);
      }));
      return function (_x3) {
        return _ref0.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(_this, "updateFormApplications", function () {
      var currentApplication = _this.props.currentApplication;
      var _this$state = _this.state,
        applications = _this$state.applications,
        form = _this$state.form;
      _this.setState({
        applications: [currentApplication].concat((0, _toConsumableArray2.default)(applications)),
        form: _objectSpread(_objectSpread({}, form), {}, {
          applicationId: currentApplication.id.toString()
        })
      });
    });
    return _this;
  }
  (0, _inherits2.default)(RequestAccessModal, _React$Component);
  return (0, _createClass2.default)(RequestAccessModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
        asset = _this$props3.asset,
        managedInstances = _this$props3.managedInstances,
        onLoadInstances = _this$props3.onLoadInstances;
      var organizationId = asset.organization.id,
        groupId = asset.groupId,
        assetId = asset.assetId,
        minorVersion = asset.minorVersion,
        versionGroup = asset.versionGroup;
      var assetParams = {
        organizationId: organizationId,
        groupId: groupId,
        assetId: assetId,
        minorVersion: minorVersion,
        versionGroup: versionGroup
      };
      if (!managedInstances) {
        onLoadInstances(assetParams);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var previousApplication = prevProps.currentApplication;
      var currentApplication = this.props.currentApplication;
      var previousApplicationId = previousApplication === null || previousApplication === void 0 ? void 0 : previousApplication.id;
      var currentApplicationId = currentApplication === null || currentApplication === void 0 ? void 0 : currentApplication.id;
      if (currentApplicationId && currentApplicationId !== previousApplicationId) {
        this.updateFormApplications();
      }
    }
  }, {
    key: "getVisibleManagedInstances",
    value: function getVisibleManagedInstances() {
      var _this$props4 = this.props,
        managedInstances = _this$props4.managedInstances,
        isPublicPortal = _this$props4.isPublicPortal;
      return isPublicPortal ? managedInstances.filter(function (instance) {
        return instance.isPublic;
      }) : managedInstances;
    }
  }, {
    key: "getSlaTierPlaceholder",
    value: function getSlaTierPlaceholder() {
      var _this$state2 = this.state,
        slaTiers = _this$state2.slaTiers,
        isLoadingSLATiers = _this$state2.isLoadingSLATiers;
      var hasSlaTiers = slaTiers && slaTiers.length > 0;
      if (isLoadingSLATiers) {
        return 'Loading SLA tiers';
      }
      return hasSlaTiers ? 'Select SLA tier' : 'Instance does not have SLA tiers';
    }
  }, {
    key: "getInstancePlaceholder",
    value: function getInstancePlaceholder() {
      var _this$props5 = this.props,
        asset = _this$props5.asset,
        isLoadingInstances = _this$props5.isLoadingInstances;
      if (isLoadingInstances) {
        return isAPIGroup(asset) ? 'Loading group instances' : 'Loading API instances';
      }
      return isAPIGroup(asset) ? 'Select group instance' : 'Select API instance';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props6 = this.props,
        asset = _this$props6.asset,
        errors = _this$props6.errors,
        isLoadingInstances = _this$props6.isLoadingInstances,
        isSubmiting = _this$props6.isSubmiting,
        isHidden = _this$props6.isHidden,
        className = _this$props6.className,
        renderSLATiers = _this$props6.renderSLATiers,
        renderUnderlyingTerms = _this$props6.renderUnderlyingTerms;
      var _this$state3 = this.state,
        applications = _this$state3.applications,
        isLoadingApplications = _this$state3.isLoadingApplications,
        isLoadingSLATiers = _this$state3.isLoadingSLATiers,
        form = _this$state3.form,
        slaTiers = _this$state3.slaTiers;
      var labelId = 'request-access-modal-title';
      var slaTiersOptions = slaTiers.map(function (_ref1) {
        var id = _ref1.id,
          name = _ref1.name;
        return {
          value: id,
          label: name
        };
      });
      var hasSlaTiers = slaTiersOptions && slaTiersOptions.length > 0;
      return /*#__PURE__*/_react.default.createElement(_Form.default, {
        className: className,
        onSubmit: this.handleSubmit,
        onChange: this.handleChange,
        value: form,
        testId: "request-access-form"
      }, /*#__PURE__*/_react.default.createElement(_Modal.default, {
        renderInBody: false,
        onClickOverlay: this.handleClose,
        className: styles.modal,
        ariaLabelledBy: labelId
      }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
        testId: "request-access-modal-header",
        onClose: this.handleClose,
        className: styles.header
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: labelId,
        className: styles.title
      }, "Request access")), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
        className: styles.body
      }, errors && errors.length > 0 ? /*#__PURE__*/_react.default.createElement("div", {
        role: "alert",
        "aria-live": "assertive",
        className: styles.errors
      }, (errors || []).map(function (event) {
        return event.message;
      }).join('. ')) : null, /*#__PURE__*/_react.default.createElement(_Select.default, {
        theme: SelectTheme,
        label: isAPIGroup(asset) ? 'Group Instance' : 'API Instance',
        name: "instanceId",
        disabled: isLoadingInstances,
        isLoading: isLoadingInstances,
        options: this.getManagedInstances(),
        optionRenderer: optionRenderer,
        placeholder: this.getInstancePlaceholder(),
        testId: "select-instance",
        value: form.instanceId,
        required: true,
        autosize: false,
        menuRenderer: isAPIGroup(asset) ? undefined : _utils.menuRenderer
      }), /*#__PURE__*/_react.default.createElement(_Select.default, {
        label: "Application",
        name: "applicationId",
        theme: isHidden ? ApplicationSelectThemeHidden : ApplicationSelectTheme,
        disabled: isLoadingApplications,
        isLoading: isLoadingApplications,
        options: applications.map(function (_ref10) {
          var id = _ref10.id,
            name = _ref10.name;
          return {
            value: id,
            label: name
          };
        }),
        optionRenderer: optionRenderer,
        placeholder: isLoadingApplications ? 'Loading applications' : 'Select application',
        testId: "select-app",
        value: form.applicationId,
        autosize: false,
        required: true,
        fixedActionComponent: form.instanceId ? function () {
          return /*#__PURE__*/_react.default.createElement(CreateNewApplicationButton, {
            onClick: _this2.onCreateNewApplication
          });
        } : null
      }), /*#__PURE__*/_react.default.createElement(_Select.default, {
        label: "SLA tier",
        name: "slaTier",
        theme: SelectTheme,
        disabled: isLoadingSLATiers || !form.instanceId || !hasSlaTiers,
        isLoading: isLoadingSLATiers,
        options: slaTiersOptions,
        optionRenderer: optionRenderer,
        placeholder: this.getSlaTierPlaceholder(),
        testId: "select-sla-tier",
        value: form.slaTier,
        autosize: false,
        required: isLoadingSLATiers || !form.instanceId || hasSlaTiers
      }), form.slaTierLimits ? /*#__PURE__*/_react.default.createElement(_TierPreview.default, {
        testId: "sla-tier-limits",
        className: styles.slaTierLimits,
        limits: form.slaTierLimits.map(function (_ref11) {
          var timeUnit = _ref11.timeUnit,
            timePeriod = _ref11.timePeriod,
            maximumRequests = _ref11.maximumRequests;
          return {
            maximumRequests: maximumRequests,
            period: timePeriod,
            unit: timeUnit
          };
        })
      }) : null, form.slaTier ? renderSLATiers({
        slaTiers: slaTiers,
        slaTier: form.slaTier
      }) : null, /*#__PURE__*/_react.default.createElement(_AcceptTerms.default, {
        asset: asset,
        testId: "accept-terms",
        apiGroupInstanceId: isAPIGroup(asset) ? form.instanceId : null,
        renderUnderlyingTerms: renderUnderlyingTerms,
        required: true
      })), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
        className: styles.footer
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        kind: "tertiary",
        onClick: this.handleClose,
        testId: "request-access-cancel",
        noFill: true
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.default, {
        testId: "request-access",
        kind: "primary",
        type: "submit",
        isLoading: isSubmiting
      }, isSubmiting ? 'Requesting ...' : 'Request access'))));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(RequestAccessModal, "contextType", _exchangeReactHooks.ModalContext);
(0, _defineProperty2.default)(RequestAccessModal, "defaultProps", {
  renderSLATiers: function renderSLATiers() {
    return null;
  },
  renderUnderlyingTerms: function renderUnderlyingTerms() {
    return null;
  },
  className: null,
  domain: null
});
//# sourceMappingURL=RequestAccessModal.js.map